// extracted by mini-css-extract-plugin
module.exports = {"row":"OrderTotal_row__2H8Vm","value":"OrderTotal_value__1xa3U"};